module.exports = {
  "我们为您提供了AI赚币、贷款、新币申购的功能":"Chúng tôi cung cấp cho bạn các chức năng kiếm tiền, cho vay và đăng ký tiền tệ mới bằng AI.",
  "AI赚币介绍":"Giới thiệu về Quỹ AI",
  "账户":"Tài khoản",
  "盈亏":"Lợi nhuận và thua lỗ",
  "平仓时间":"Thời gian đóng cửa",
  "止盈止损":"Chốt lãi và dừng lỗ",
  "止盈":"chốt lời",
  "止损":"chặn đứng tổn thất",
  "订单详情":"chi tiết đặt hàng",
  "取消":"Hủy bỏ",
  "订单时间":"thời gian phục vụ",
  "搜索币种":"Tìm kiếm tiền tệ",
  "选择币种":"Chọn loại tiền tệ",
  "请输入手数":"Vui lòng nhập số lô",
  "自选":"Không bắt buộc",
  "兑换":"Trao đổi",
  "金额":"Số lượng",
  "得到":"lấy",
  "兑换手续费为":"Phí trao đổi là",
  "立即发送":"gửi ngay lập tức",
  "申请时间":"thời gian nộp đơn",
  "接收数量":"Nhận số lượng",
  "手续费":"phí xử lý",
  "充值":"nạp tiền",
  "提现":"rút",
  "合约交易":"giao dịch hợp đồng",
  "看涨":"lạc quan",
  "看跌":"giảm giá",
  "请输入数量":"Vui lòng nhập số lượng",
  "买入":"mua",
  "收益":"thu nhập",
  "杠杆":"đòn bẩy",
  "限价":"giới hạn giá",
  "市价":"Giá thị trường",
  "卖出":"bán",
  "请输入价格":"Vui lòng nhập giá",
  "开仓成功":"Vị thế được mở thành công",
  "交易账户":"tài khoản giao dịch",
  "交易币种":"Tiền tệ giao dịch",
  "交易方向":"Hướng giao dịch",
  "交易数量":"Số lượng giao dịch",
  "开仓价格":"Giá mở cửa",
  "保证金":"lề",
  "确认":"xác nhận",
  "持仓":"Chức vụ",
  "当前委托":"Thứ tự hiện tại",
  "历史记录":"kỷ lục lịch sử",
  "买涨":"mua lên",
  "买跌":"Mua hoặc bán",
  "撤单":"Hủy đơn hàng",
  "当前价格":"Giá hiện tại",
  "平仓":"Đóng vị thế",
  "总量":"tổng cộng",
  "已完成":"hoàn thành",
  "福利专区":"Khu phúc lợi",
  "请时刻关注福利活动，我们将不定期发布":"Hãy luôn chú ý đến các hoạt động phúc lợi, chúng tôi sẽ phát hành chúng theo thời gian",
  "发行日期":"ngày phát hành",
  "上市日期":"Ngày niêm yết",
  "请关注":"Làm ơn chú ý",
  "公告发布":"Thông báo phát hành",
  "实际到账":"Đến thực tế",
  "期权交易":"giao dịch quyền chọn",
  "首页":"trang đầu",
  "提示":"gợi ý",
  "请用钱包APP访问":"Vui lòng sử dụng APP ví để truy cập",
  "矿池赚币":"Nhóm khai thác kiếm được tiền",
  "快捷买币":"Mua xu nhanh chóng",
  "更多币种，快捷买币":"Nhiều tiền hơn, mua tiền nhanh chóng",
  "去购买":"đi mua",
  "公告":"thông báo",
  "P2P交易":"Giao dịch P2P",
  "P2P市场":"thị trường P2P",
  "链接加密未来":"Liên kết với tương lai tiền điện tử",
  "开始交易":"Bắt đầu giao dịch",
  "交易产品":"Sản phẩm kinh doanh",
  "最低手续费":"Phí xử lý tối thiểu",
  "合作单位":"có",
  "交易品种":"Kinh doanh giống",
  "更多":"Hơn",
  "交易品种市场趋势":"Xu hướng thị trường sản phẩm kinh doanh",
  "行情":"Báo giá",
  "交易":"buôn bán",
  "货币":"tiền tệ",
  "资产":"tài sản",
  "注册":"đăng ký",
  "登录":"Đăng nhập",
  "关于我们":"về chúng tôi",
  "联系我们":"liên hệ chúng tôi",
  "公告中心":"Trung tâm thông báo",
  "条款说明":"Các điều khoản và điều kiện",
  "用户协议":"sự thỏa thuận của người dùng",
  "隐私协议":"thỏa thuận quyền riêng tư",
  "法律声明":"Thông báo pháp lý",
  "风险告知":"Thông báo rủi ro",
  "服务":"Phục vụ",
  "充币":"Gửi tiền xu",
  "提币":"Rút xu",
  "新币申购":"Đăng ký tiền tệ mới",
  "AI赚币":"AI kiếm được tiền",
  "产品":"sản phẩm",
  "永续合约":"Hợp đồng vĩnh viễn",
  "期货合约":"hợp đồng tương lai",
  "币币交易":"Giao dịch tiền điện tử",
  "我的资产":"tài sản của tôi",
  "记录":"Ghi",
  "可用":"Có sẵn",
  "折合":"chuyển đổi",
  "私募币种":"Đồng tiền phát hành riêng lẻ",
  "私募币种上线,您可以在这里买到您觉得有潜力的新币":"Các đồng tiền phát hành riêng tư đang trực tuyến, bạn có thể mua những đồng tiền mới mà bạn cho rằng có tiềm năng tại đây",
  "名称":"tên",
  "价格":"giá ",
  "4H涨跌":"Tăng giảm 4H",
  "成交量":"Âm lượng",
  "操作":"vận hành",
  "为您的资产保驾护航":"Bảo vệ tài sản của bạn",
  "行业领先多重安全风控体系,7*24小时全年无休平台监控，全方位保护资产 安全":"Nhiều hệ thống kiểm soát rủi ro bảo mật hàng đầu trong ngành, giám sát nền tảng 24/7, bảo vệ an ninh tài sản toàn diện",
  "多重":"nhiều",
  "安全风控机制":"Cơ chế kiểm soát rủi ro bảo mật",
  "全球领先的交易市场":"Thị trường giao dịch hàng đầu thế giới",
  "轻松创建个人专属资产账户，探索、购买和交易全球的优质 交易品类":"Dễ dàng tạo tài khoản tài sản độc quyền cá nhân để khám phá, mua và giao dịch các danh mục giao dịch chất lượng cao trên toàn thế giới",
  "品种":"Đa dạng",
  "手机PC端均可使用":"Có sẵn trên cả thiết bị di động và PC",
  "随时随地开始交易":"Bắt đầu giao dịch mọi lúc, mọi nơi",
  "我们提供强大的图表分析工具：五十多种技术指标和盘面 分析工具。安全可靠、易于使用而又具备高阶投资者使用 的功能特点，成为在线投":"Chúng tôi cung cấp các công cụ phân tích biểu đồ mạnh mẽ: hơn 50 chỉ báo kỹ thuật và công cụ phân tích đĩa. Nó an toàn, đáng tin cậy, dễ sử dụng và có các tính năng dành cho các nhà đầu tư cao cấp, khiến nó trở thành nền tảng đầu tư trực tuyến.",
  "点击下载":"bấm chuột để tải xuống",
  "安卓市场":"Chợ Android",
  "苹果商店":"cửa hàng táo",
  "私募币种限量上线,您可以在这里买到您觉得有潜力的新币":"Một số lượng hạn chế các đồng tiền phát hành riêng tư đang trực tuyến. Bạn có thể mua những đồng tiền mới mà bạn cho rằng có tiềm năng tại đây.",
  "24H涨跌":"Thăng trầm 24H",
  "探索无限可能":"Khám phá những khả năng vô tận",
  "新币申购功能上线":"Chức năng đăng ký tiền tệ mới đang trực tuyến",
  "开始使用":"bắt đầu sử dụng",
  "AI赚币计划进行中":"Kế hoạch quỹ AI đang được tiến hành",
  "开始AI赚币,稳定收益,高回报率,让您 躺着赚币":"Bắt đầu một quỹ AI, với thu nhập ổn định và tỷ suất lợi nhuận cao, cho phép bạn kiếm tiền ngay cả khi nằm",
  "贷款功能上线":"Chức năng cho vay trực tuyến",
  "当您没钱的时候,您可以申请贷款,最快 当天下发 ":"Khi không có tiền, bạn có thể đăng ký vay và sẽ được cấp ngay trong ngày",
  "新币限量上线,您可以在这里买 到您觉得有潜力的新币":"Một số lượng hạn chế các đồng tiền mới đang trực tuyến. Bạn có thể mua những đồng tiền mới mà bạn cho rằng có tiềm năng ở đây.",
  "模拟交易":"giao dịch mô phỏng",
  "限购":"Giới hạn mua hàng",
  "次":"hạng hai",
  "关闭模拟":"Tắt mô phỏng",
  "数量":"Số lượng",
  "请输入提币地址提币手续费为":"Vui lòng nhập địa chỉ rút tiền. Phí rút tiền là.",
  "提币手续费为":"Phí rút tiền là",
  "请输入提币地址":"Vui lòng nhập địa chỉ rút tiền",
  "我已阅读并知晓":"Tôi đã đọc và hiểu",
  "贷款服务协议":"Thỏa thuận dịch vụ cho vay",
  "level1": {
    "name": "Tên thật",
    "address": "Chi tiết địa chỉ cư trú hiện tại",
    "bank_number": "Tài khoản ngân hàng",
    "wc": "OK",
    "name_nodata": "Không được để trống tên",
    "id_card_nodata": "Không được để trống số ID",
    "address_nodata": "Không được để trống địa chỉ",
    "bank_number_nodata": "Không được để trống tài khoản ngân hàng",
    "input-username": "Vui lòng nhập tên thật của bạn",
    "zjhm": "Số ID",
    "input-idcard": "Vui lòng nhập số ID",
    "input-address": "Vui lòng điền địa chỉ",
    "zjlx": "Loại ID hợp lệ",
    "qxzzjlx": "Vui lòng chọn loại ID",
    "sfz": "Thẻ ID",
    "hz": "Hộ chiếu",
    "jsz": "Bằng lái xe",
    "khh": "Tài khoản đang mở",
    "qsrkhh": "Vui lòng nhập ngân hàng",
    "yhkh": "Tài khoản ngân hàng",
    "qsryhkh": "Vui lòng nhập số tài khoản ngân hàng",
    "gjlb": "Danh sách các quốc gia",
    "qxzgjlb": "Vui lòng chọn Quốc gia / Vùng"
  },
  "my": {
    "mqrcode": "Mã QR của tôi",
    "as": "Cài đặt",
    "pc": "Chứng chỉ sơ cấp",
    "ac": "Chứng chỉ cao cấp",
    "ms": "Chia sẻ",
    "me": "Thu nhập của tôi",
    "zsr": "Tổng doanh thu",
    "mp": "Khuyến mại của tôi",
    "yqhy": "Mời bạn bè",
    "ar": "Hồ sơ",
    "hc": "Trung tâm trợ giúp",
    "nodata": "Không có dữ liệu",
    "med": "Chia nhỏ thu nhập",
    "aes": "Thu nhập tích lũy (USDT)",
    "one": "Thế hệ thứ nhất     ",
    "two": "Thế hệ thứ hai",
    "three": "Thế hệ thứ ba",
    "four": "Thế hệ thứ tư",
    "ones": "Người thế hệ thứ nhất",
    "twos": "Người thế hệ thứ hai",
    "threes": "Người thế hệ thứ ba",
    "fours": "Người thế hệ thứ tư",
    "promotion": "Số lượng khuyến mại",
    "customers": "Thu nhập của tôi",
    "wdzc": "Tài sản của tôi",
    "wdzc1": "Tài sản của tôi",
    "wyfx": "Chia sẻ",
    "wdsy": "Thu nhập của tôi",
    "wdtg": "Khuyến mại của tôi",
    "zhjl": "Hồ sơ",
    "zxkf": "Liên hệ chúng tôi",
    "wdxx": "Tin nhắn của tôi",
    "smrz":"Xác thực KYC",
    "sfyz":"Xác thực KYC"
  },
  "footer": {
    "home": "Trang chủ",
    "quotation": "Thị trường",
    "currency": "Trao đổi",
    "lever": "Hợp đồng",
    "my": "tài khoản",
    "lc": "Lãi USDT đã thu được"
  },
  home:{
      user:'Lựa chọn chung của người dùng',
      start:'Bắt đầu giao dịch',
      trading:'Sản phẩm kinh doanh',
      fee:'Phí xử lý tối thiểu',
      co:'có',
      varieties:'Kinh doanh giống',
      leading:'Dẫn đầu sự đổi mới và khám phá web3',
      market:'Xu hướng thị trường sản phẩm kinh doanh',
      explore:'Khám phá những khả năng vô tận',
      newcurrency:'Chức năng đăng ký tiền tệ mới đang trực tuyến!',
      alimited:'Tiền mới đang trực tuyến, bạn có thể mua tiền mới mà bạn cho là có tiềm năng tại đây',
      get_start:'Bắt đầu',
      ai_coin:'Kế hoạch kiếm tiền Nhóm khai thác đang được tiến hành',
      ai_text:'Bắt đầu kiếm xu với Nhóm khai thác, thu nhập ổn định, tỷ lệ hoàn vốn cao, cho phép bạn kiếm xu ngay khi nằm',
      loan:'Chức năng cho vay trực tuyến',
      loan_text:'Khi không có tiền, bạn có thể đăng ký vay và sẽ được cấp ngay trong ngày',
      mobile_pc:'Được các y tá sử dụng trên PC di động',
      pc_anytime:'Bắt đầu giao dịch mọi lúc, mọi nơi:',
      pc_text:'Chúng tôi cung cấp các công cụ phân tích biểu đồ mạnh mẽ: hơn 50 chỉ báo kỹ thuật và công cụ phân tích đĩa. Đòn bẩy an toàn, đáng tin cậy, dễ sử dụng và các tính năng đòn bẩy cao đã trở thành nền tảng tiêu chuẩn cho đầu tư trực tuyến.',
      mobile_down:'bấm chuột để tải xuống',
      mobile_android:'Chợ Android',
      mobile_ios:'cửa hàng táo',
      open_text:'Bạn có thể đăng ký tài khoản giao dịch thực hoặc dùng thử tài khoản demo miễn phí với một phần ba chi phí.',
      open_account:'một tài khoản',
      tocomplete:'hoàn thành',
      walletlogin:'Đăng nhập ví',
    thedoor:'Cánh cửa đầu tư và quản lý tài chính',
    weare:'Chúng tôi là nơi đáng tin cậy nhất để quản lý ngoại hối và kỹ thuật số.',
    emailaddress:'Địa chỉ email',
    allprices:'Tất cả giá',
    chart:'Biểu đồ xu hướng kim loại quý',
    gold:'Blkketf là phần mềm giao dịch rất thiết thực, bạn có thể xem biểu đồ xu hướng trực tiếp trên trang chủ.',
    more:'Nhiều chức năng thiết thực hơn',
    weprovide:'Chúng tôi cung cấp cho bạn các chức năng kiếm tiền, cho vay và đăng ký tiền tệ mới bằng Nhóm khai thác.',
    zzc:'Tổng tài sản',
    gmjy:'Bạn có thể mua một lượng nhỏ tiền điện tử và bắt đầu giao dịch ngay lập tức'
  },
  propagate:{
    ai:'Giới thiệu về nhóm khai thác thông minh',
    how:'Giới thiệu về Giám đốc Nhượng quyền Quỹ',
    brick:'Tiền gạch',
  },
  propagatebuy:{
    joinai:'Tham gia nhóm khai thác thông minh',
    risk:'0 rủi ro, lợi nhuận ổn định',
    daily:'Thu nhập hàng ngày sẽ được phân phối vào tài khoản ví USDT của bạn',
    zero:'Quỹ lưu ký của bạn không có rủi ro',
    youcan:'Bạn có thể rút tiền bất cứ lúc nào',
    airobot:'Robot AI hoạt động 24/7 365*',
  },
  "index": {
    "wdzc": "Tài sản của tôi (USDT)",
    "dl": "đăng nhập",
    "zxkf": "Liên hệ chúng tôi",
    "increase": "Danh sách tiền lãi",
    "usercenter": "Trung tâm cá nhân",
    "security": "Trung tâm Bảo mật",
    "address": "Địa chỉ rút tiền",
    "aboutus": "Về chúng tôi",
    "vol": "Khối lượng 24 giờ",
    "kjcb": "Tiền ký quỹ",
    "zcbz": "BTC, USDT...",
    "logout":"đăng xuất",
    "language":"Ngôn ngữ"
  },
  "transaction": {
    "buy": "Mua",
    "sell": "Bán",
    "pwd": "Mật khẩu giao dịch",
    "inputnum": "Nhập số lượng",
    "limit": "Giới hạn",
    "avaiable": "Khả dụng",
    "turnover": "Giao dịch",
    "handicap": "Điều bất lợi",
    "number": "Số lượng",
    "nonumber": "Số lượng còn tồn",
    "numbered": "Số lượng đã hoàn tất",
    "price": "Giá",
    "marketprice": "Giá thị trường",
    "cancel": "Hủy",
    "time": "Thời gian",
    "nomore": "Không còn thêm",
    "nodata": "Không có hồ sơ",
    "getmore": "Tải thêm",
    "mycommission": "Giao dịch ủy thác",
    "currentbuy": "Lệnh hiện thời (Mua)",
    "currentsell": "Lệnh hiện thời (Bán)    ",
    "his": "Lịch sử (Hoàn tất)",
    "currency": "Tiền tệ",
    "option": "Vận hành",
    "wtime": "Thời gian hoàn thành",
    "wnumber": "Số lượng đã hoàn thành",
    "wprice": "Mức giá hoàn thành"
  },
  "mk": {
    "high": "Cao",
    "low": "Thấp",
    "vol": "Khối lượng 24 giờ",
    "newPrice": "Giá mới nhất",
    "product": "Sản phẩm",
    "name":"Tên",
    "rank": "Danh sách tiền lãi"
  },
  "deals": {
    "issue_time": "Thời gian công bố",
    "issue_number": "Mã số phát hành",
    "white_book": "Sách trắng",
    "weburl": "Trang web chính thức",
    "video_url": "Video",
    "introduction": "Thông tin",
    "onhand": "1 lô =",
    "position": "Vị thế",
    "leverorder": "Lệnh đòn bẩy",
    "leverposition": "Vị thế đòn bẩy",
    "inputprice": "Nhập giá",
    "inputmul": "Nhập hệ số",
    "selectmul": "Chọn hệ số",
    "onehand": "1 lô =",
    "hand": "Lô giao dịch",
    "marketval": "Giá trị thị trường",
    "bond": "Trái phiếu",
    "balance": "Số dư",
    "type": "Loại",
    "risk": "Tỷ lệ rủi ro",
    "total": "Lợi nhuận tổng",
    "onekey": "Thanh khoản một lần nhấp chuột",
    "makemore": "(Dài hạn)",
    "makeless": "(Ngắn hạn)",
    "current": "Lệnh mở",
    "all": "Tất cả các",
    "weing": "Hoa hồng",
    "tding": "Đang giao dịch",
    "ping": "Đang đóng",
    "pied": "Đã đóng",
    "ceiled": "Đã rút",
    "weprice": "Giá hoa hồng",
    "oprice": "Giá mở cửa",
    "nowprice": "Giá hiện thời",
    "zyprice": "Giá chốt lãi",
    "zsprice": "Giá cắt lỗ",
    "canbond": "Ký quỹ khả dụng",
    "optime": "Thời gian mở cửa",
    "pgtime": "Thời gian đóng cửa",
    "znum": "Số tiền đã chuyển đổi",
    "gprice": "Phí giao dịch qua đêm",
    "pcang": "Đóng",
    "revoke": "Rút tiền",
    "fee": "Phí",
    "you": "Giá thị trường tối ưu"
  },
  "assets": {
    "copy": "Sao chép",
    "avaiable": "Khả dụng",
    "lock": "Đóng băng",
    "conversion": "Chuyển đổi",
    "exact": "Tài khoản giao dịch",
    "num": "Số lượng",
    "time": "Thời gian",
    "all": "Tất cả các",
    "canuse": "Khả dụng",
    "cmoney": "Tiền ký quỹ",
    "tmoney": "Rút tiền",
    "caddress": "Địa chỉ tiền ký quỹ",
    "copyaddress": "Sao chép địa chỉ",
    "taddress": "Địa chỉ rút tiền",
    "taddressm": "Vui lòng nhập địa chỉ rút tiền",
    "rate": "Phí",
    "dnum": "Số tiền đến",
    "more": "Tải thêm",
    "nodata": "Không có hồ sơ",
    "yczc": "Ẩn tài sản bạn không có",
    "total":"Chuyển đổi tài sản (USDT)"
  },
  "td": {
    "drecord": "Bản ghi lệnh",
    "orecord": "Lệnh đã hoàn tất",
    "filter": "Bộ lọc",
    "dstatus": "Trạng thái lệnh",
    "nofinish": "Hoàn tác",
    "finished": "Đã hoàn tất",
    "ceiled": "Đã hủy",
    "reset": "Đặt lại",
    "confirm": "OK",
    "time": "Thời gian",
    "num": "Số lượng",
    "price": "Giá",
    "ptime": "Thời gian đặt lệnh",
    "receiver": "Người hưởng",
    "open": "Tài khoản đang mở",
    "pwd": "Mật khẩu giao dịch",
    "ppwd": "Vui lòng nhập mật khẩu giao dịch",
    "sure": "OK",
    "realName": "Tên thật",
    "pnum": "Vui lòng nhập số tiền",
    "buyNum": "Số lượng mua",
    "currency": "Tiền tệ"
  },
  "fat": {
    "ceil": "Hủy",
    "num": "Số lượng",
    "submit": "Đặt một lệnh",
    "pwd": "Mật khẩu giao dịch",
    "ppwd": "Vui lòng nhập mật khẩu giao dịch",
    "sure": "Xác nhận",
    "auHigh": "Chứng chỉ cao cấp"
  },
  "auth": {
    "bh": "Đã bị từ chối",
    "mycenter": "Trung tâm cá nhân",
    "test": "KYC",
    "testing": "Đang xem xét",
    "name": "Tên",
    "account": "Tài khoản",
    "id_card_face": "Vui lòng tải lên mặt trước của thẻ ID\n",
    "id_card_back": "Vui lòng tải lên mặt sau của thẻ ID",
    "updata": "Gửi",
    "updata_again": "Gửi lại   "
  },
  "code": {
    "notice": "Thông báo     "
  },
  "safe": {
    "title": "Bảo mật tài khoản   ",
    "center": "Trung tâm Bảo mật",
    "yysz": "Ngôn ngữ",
    "ssms": "Chế độ nền tối   ",
    "gywm": "Về chúng tôi",
    "lgpwd": "Mật khẩu đăng nhập ",
    "resetpwd": "Chỉnh sửa mật khẩu",
    "paccount": "Số điện thoại di động hoặc hộp thư của bạn",
    "reset": "Sửa đổi",
    "ceil": "Hủy",
    "pcode": "mã xác nhận",
    "sure": "Xác nhận",
    "newPwd": "Đặt lại mật khẩu",
    "ppwd": "Mật khẩu",
    "reppwd": "Mật khẩu lần nữa",
    "repwd": "Đặt lại mật khẩu",
    "zpwd": "Mật khẩu giao dịch"
  },
  "met": {
    "open": "Tên trên tài khoản ngân hàng",
    "bank": "Tài khoản ngân hàng",
    "realname": "Tên thật",
    "save": "Lưu",
    "popen": "Vui lòng nhập tên trên tài khoản ngân hàng",
    "pbank": "Vui lòng nhập ngân hàng và số tài khoản",
    "pname": "Vui lòng nhập tên thật của bạn"
  },
  "ads": {
    "tas": "Địa chỉ rút tiền",
    "address": "Địa chỉ",
    "noads": "Bạn chưa có địa chỉ.",
    "adds": "Địa chỉ",
    "remark": "Chú thích",
    "cel": "Xóa"
  },
  "jc": {
    "ppwd": "Mật khẩu"
  },
  "lg": {
    "qbdl":"Đăng nhập ví",
    "welcome": "Chào mừng! Vui lòng đăng nhập",
    "lgtel": "Đăng nhập bằng số điện thoại di động",
    "lgeml": "Đăng nhập bằng email",
    "paccount": "Số điện thoại hoặc Email",
    "ppwd": "Mật khẩu",
    "ppwd2": "Vui lòng xác nhận mật khẩu của bạn",
    "pcode": "mã xác nhận",
    "qsryqm": "Mã mời",
    "noaccount": "Bạn chưa có tài khoản?",
    "register": "Đăng ký",
    "phregister": "Đăng ký bằng số điện thoại di động",
    "emregister": "Đăng ký bằng email",
    "pphone": "số điện thoại",
    "ceil": "Hủy",
    "send": "Nhận CAPTCHA",
    "sure": "OK",
    "email": "địa chỉ email",
    "emtest": "Xác nhận email",
    "pemcode": "mã xác nhận",
    "ppcode": "Vui lòng nhập mã xác nhận của bạn",
    "ftpwd": "Bạn quên mật khẩu?",
    "ptext": "Số điện thoại di động hoặc hộp thư của bạn",
    "yzm": "Mã xác minh",
    "mm": "Mật khẩu",
    "qrmm": "Xác nhận mật khẩu",
    "language":"Ngôn ngữ",
    "qregister":"Đăng ký",
    "lgs":"đăng nhập",
    "ftpwds":"Bạn quên mật khẩu",
    "kjzc": "Liên hệ đăng ký nhanh",
    "kjzc1": "Không thể nhận Captcha?",
    "kjzc2": "Đăng kí nhanh",
    "wyzx": "Tôi đã biết",
    "qtxyxzh": "Quan trọng: Vui lòng điền vào một địa chỉ email hoặc số điện thoại di động hợp lệ, có thể được sử dụng để lấy lại mật khẩu của bạn",
    "next": "Bước tiếp theo"
  },
  "gjrz": {
    "title": "Chứng chỉ cao cấp",
    "t1": "1. Hỗ trợ các ảnh dưới 8MB và định dạng JPG, JPEG hoặc PNG.",
    "t2": "2. Các ảnh tài liệu ID phải rõ ràng và sẽ không bị chỉnh sửa hoặc che khuất. Mã số tài liệu ảnh cá nhân và tên của chủ sở hữu tài liệu phải dễ nhìn.",
    "t3": "3. Các ảnh phải được chụp mà không có bất kỳ vật che đầu nào và không khuyến khích trang điểm khi chup. Các đường nét khuôn mặt trong ảnh phải rõ ràng và dễ nhận biết và không để lộ toàn bộ tay.",
    "t4": "OK",
    "bh": "Đã bị từ chối",
    "shz": "Đang xem xét",
    "shtg": "Đã phê duyệt",
    "sczjz": "Tải lên ảnh ID",
    "sczjzmz": "Tải lên ảnh mặt trước của tài liệu ID",
    "sczjbmz": "Tải lên ảnh mặt sau của tài liệu ID",
    "scgrqmz": "Tải lên các tài liệu ID và chữ ký cá nhân"
  },
  "chongzhi": {
    "title": "Tiền ký quỹ",
    "cbjl": "Hồ sơ tiền ký quỹ",
    "t1": "Số lượng",
    "t2": "Vui lòng nhập số tiền",
    "t3": "diễn tả(Không bắt buộc)",
    "t4": "Vui lòng nhập mô tả",
    "t5": "Ảnh phiếu mua hàng",
    "t6": "OK",
    "t7": "Tên chuỗi",
    "t8": "Mã QR",
    "t9": "Lưu mã QR",
    "t10": "Địa chỉ tiền ký quỹ",
    "t11": "Sao chép",
    "zy": "Quan trọng",
    "tips1": "Vui lòng không nạp bất kỳ tài sản nào không phải bằng đơn vị tiền tệ này vào địa chỉ trên nếu không sẽ không thể truy xuất tài sản",
    "tips2": "1. Khả năng tương thích của ví / nền tảng: nghĩa là mạng được hỗ trợ; nếu nền tảng đích không hỗ trợ mạng rút tiền của bạn, thì không thể truy xuất tài sản.",
    "tips3": "2. Mạng nạp tiền của bạn và nền tảng mục tiêu giống nhau; nếu bạn chọn địa chỉ mục tiêu là mạng Ethereum, nhưng người nạp tiền chọn chuỗi thông minh TRC20, bạn có thể không truy xuất được tài sản kỹ thuật số của mình.",
    "tips4": "3. Đảm bảo rằng địa chỉ và số tiền của bạn là chính xác trước khi nạp tiền.",
    "tips5": "Nhắc nhở: Do tính ẩn danh và tính riêng tư của mạng khối, một khi bạn nhập sai thông tin, bạn sẽ mất tài sản tương ứng. Vui lòng kiểm tra kỹ địa chỉ và số lượng nạp tiền của bạn"
  },
  "tibi": {
    "title": "Rút",
    "tbjl": "Hồ sơ rút tiền",
    "t1": "Địa chỉ rút tiền",
    "t2": "Vui lòng nhập địa chỉ rút tiền",
    "t3": "Số lượng rút",
    "qsrtbsl": "Vui lòng nhập số lượng của tiền tệ sẽ rút",
    "t4": "Tối thiểu",
    "t5": "Mật khẩu giao dịch",
    "t6": "Vui lòng nhập mật khẩu giao dịch",
    "t7": "Phí",
    "t8": "Số tiền đến",
    "t9": "OK",
    "sc": "Xóa",
    "bj": "Chỉnh sửa",
    "bq": "Thẻ (Ghi nhớ)",
    "qsrbq": "Vui lòng nhập thẻ",
    "yhktx": "Rút qua thẻ ngân hàng",
    "yhmc": "Tên ngân hàng",
    "qsryhmc": "Vui lòng nhập tên ngân hàng",
    "yhzh": "Tài khoản ngân hàng",
    "qsryhzh": "Vui lòng nhập số tài khoản ngân hàng",
    "gjhkdm": "Mã SWIFT",
    "qsrgjhkdm": "Vui lòng nhập mã SWIFT",
    "yhdz": "Địa chỉ ngân hàng",
    "qsryhdz": "Vui lòng nhập địa chỉ ngân hàng",
    "skrxm": "Tên người hưởng",
    "qsrskrxm": "Vui lòng nhập tên người hưởng",
    "skrdh": "Số điện thoại của người hưởng",
    "qsrskrdh": "Vui lòng nhập số điện thoại của người hưởng",
    "skrdz": "Địa chỉ của người hưởng",
    "qsrskrdz": "Vui lòng nhập địa chỉ của người hưởng"
  },
  "huazhuan": {
    "t4": "Vui lòng nhập số tiền",
    "ky": "Khả dụng",
    "t10": "OK"
  },
  "banner": {
    "title": "Chi tiết"
  },
  "download": {
    "t1": "giao dịch, ở mọi nơi",
    "xz": "Tải về"
  },
  "xgdlmm": {
    "title": "Sửa đổi mật khẩu đăng nhập",
    "zh": "Tài khoản",
    "yzm": "Mã xác minh",
    "yzmts": "mã xác nhận",
    "hqyzm": "Nhận CAPTCHA",
    "mm": "Mật khẩu",
    "qrmm": "Xác nhận mật khẩu",
    "qr": "Xác nhận",
    "zhts":"Điện thoại di động hoặc email",
    "mmts":"Mật khẩu là tổ hợp gồm 6-12 chữ số và chữ cái"
  },
  "sztkmm": {
    "title": "Đặt mật khẩu rút tiền",
    "dlmm": "Mật khẩu đăng nhập ",
    "dlmmts": "Vui lòng nhập mật khẩu đăng nhập",
    "xmm": "Mật khẩu mới",
    "mmts": "Mật khẩu gồm 6 chữ số",
    "qrmm": "Xác nhận mật khẩu",
    "qr": "Xác nhận",
    "qd": "OK",
    "sztkts": "Mẹo: Vui lòng truy cập Trung tâm Bảo mật để đặt mật khẩu giao dịch"
  },
  "rule": {
    "title": "Giới thiệu sản phẩm",
    "title2": "Quy định",
    "title3": "Sự kiện"
  },
  "news": {
    "title": "Tin nhắn của tôi",
    "ckxq": "Xem chi tiết",
    "gg": "Thông báo"
  },
  "search": {
    "qx": "Hủy"
  },
  "wdtg": {
    "wdyqlj": "Liên kết mời của tôi",
    "wdyqm": "Mã mời của tôi",
    "schbyq": "Tạo thư mời bằng áp phích",
    "ljtgsy": "Tổng doanh thu",
    "tkrs": "Số lượng thư mời",
    "ljyj": "Hoa hồng tích lũy",
    "yjmx": "Chi tiết tiền hoa hồng",
    "ljyjjl": "Phần thưởng hoa hồng tích lũy (USDT)",
    "ljsy": "Tổng doanh thu",
    "ljyqjl": "Phần thưởng thư mời tích lũy (USTD)",
    "fxd": "Chia sẻ đến",
    "bctp": "Lưu ảnh",
    "qx": "Hủy",
    "t3": "Nhận diện ảnh hoặc quét"
  },
  "bzhl": {
    "title": "Quỹ AI",
    "gz": "Quy định",
    "tgdd": "Lệnh ký quỹ",
    "zztgdzj": "Quỹ giám hộ",
    "yjjrsy": "Thu nhập hôm nay",
    "ljsy": "Tổng doanh thu",
    "tgzdd": "Lệnh giám hộ",
    "cljxcp": "Sản phẩm chiến dịch chiến lược",
    "dbxe": "Hạn mức đơn",
    "rsyl": "Lợi suất hàng ngày",
    "zq": "Chu kỳ",
    "qmr": "Mua ngay",
    "bbzhzc": "Tài sản của tài khoản",
    "dd": "Lệnh",
    "buy": "Mua",
    "jxcp": "Sản phẩm nổi bật",
    "ckdd": "Lệnh kiểm tra",
    "gd": "Xem thêm",
    "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
    "qtbz": "Các quỹ khác"
  },
  "bzhlgm": {
    "qtzq": "Chu kỳ 7 ngày USDT",
    "rsyl": "Lợi suất hàng ngày",
    "lczq": "Chu kỳ tài chính",
    "dbxe": "Hạn mức đơn",
    "pxsj": "Thời gian thanh toán cổ tức",
    "mr": "Hàng ngày",
    "dqfh": "Hoàn trả khi đến hạn",
    "tgzj": "Vốn chủ sở hữu giám hộ",
    "tqsh": "Đổi sớm",
    "yjsy": "Thu nhập dự kiến (USDT)",
    "kyzc": "Tài sản khả dụng(USDT)",
    "cpjs": "Về sản phẩm của chúng tôi",
    "tgje": "Số tiền giám hộ",
    "qsrtgje": "Vui lòng nhập số tiền giám hộ",
    "qb": "Tất cả các",
    "rm": "Mua ngay",
    "cpzq": "Chu kỳ sản phẩm",
    "gz": "Hiểu rõ quy định và lợi ích"
  },
  "bzhlwdtg": {
    "title": "Trạng thái lệnh",
    "tgz": "Giám hộ",
    "ywc": "Đã hoàn tất",
    "ysh": "Đã đổi",
    "tgje": "Số tiền giám hộ/Thời gian giám hộ",
    "rsyl": "Lợi suất hàng ngày",
    "yhl": "Đã có lãi",
    "xdsj": "Thời gian đặt lệnh",
    "sh": "Đổi",
    "ddxq": "Chi tiết lệnh",
    "ddh": "Mã số lệnh"
  },
  "bzjj": {
    "t1": "Thu nhập mỗi ngày",
    "cpld": "Những điểm nổi bật của sản phẩm",
    "scsq": "Ký quỹ & lấy về bất kỳ lúc nào",
    "pxzq": "Chu kỳ cổ tức",
    "mtxf": "Phân phối hàng ngày",
    "hqlx": "Lãi suất hiện thời",
    "zj": "Tài trợ 100%",
    "aqbz": "Bảo mật",
    "jjrsy": "Thu nhập vào ngày nghỉ lễ",
    "sybjd": "Lợi nhuận liên tục",
    "bjd": "Không gián đoạn",
    "cgcrh": "Sau khi ký quỹ thành công",
    "dtqx": "Giá trị lãi suất theo ngày",
    "jglz": "Ví dụ",
    "syjs": "Tính toán doanh thu",
    "cont2": "Tối thiểu: 10000U x 0,3%=30U",
    "cont3": "Tối đa: 10000U x 0,5%=50U",
    "gywyj": "Về thiệt hại thanh khoản",
    "wycy": "Tôi muốn tham gia"
  },
  "zyzs": {
    "title": "Chốt lãi & cắt lỗ",
    "zy": "Chốt lãi",
    "zs": "Cắt lỗ",
    "qsrzyjg": "Vui lòng nhập giá chốt lãi",
    "qsrzsjg": "Vui lòng nhập giá cắt lỗ",
    "scjg": "Giá thị trường",
    "wxts": "Lời nhắc:",
    "qr": "Xác nhận"
  },
  "bbjy": {
    "mr": "Mua",
    "mc": "Bán",
    "mai": "Mua",
    "sell": "Bán",
    "xj": "Giới hạn",
    "sj": "Giá thị trường",
    "pk": "Điều bất lợi",
    "jg": "Giá",
    "sl": "Số lượng",
    "mrl": "Khối lượng mua",
    "ss": "Số lượng",
    "mcl": "Khối lượng bán",
    "ky": "Khả dụng",
    "km": "Khả dụng",
    "ksell": "Có thể mua bán",
    "jye": "Giao dịch",
    "dqwt": "Lệnh mở",
    "lswt": "Hoa hồng lịch sử",
    "jj": "Thông tin",
    "wtzl": "Toàn bộ",
    "wtjg": "Giá hoa hồng",
    "ycjl": "Khối lượng giao dịch hoàn tất",
    "cjjj": "Mức giá giao dịch trung bình",
    "cd": "Rút tiền",
    "xd": "Đặt một lệnh",
    "ywc": "Đã hoàn tất",
    "ycd": "Đã rút",
    "wqcj": "Giao dịch hoàn tất",
    "zx": "Tùy chọn",
    "scjg": "Giá thị trường",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "qx": "Hủy"
  },
  "hyjy": {
    "mai": "Mua",
    "sell": "Bán",
    "kc": "Vị thế mở",
    "pc": "Đóng",
    "cc": "Vị thế",
    "kp": "Đóng",
    "kpc": "Đóng vị thế ngắn hạn",
    "kcc": "Vị thế",
    "kkd": "Mở vị thế dài hạn",
    "kpd": "Đóng vị thế dài hạn",
    "kkk": "Mở vị thế ngắn hạn",
    "xj": "Giới hạn",
    "sj": "Giá thị trường",
    "xjwt": "Lệnh giới hạn",
    "sjwt": "Giá thị trường",
    "pk": "Điều bất lợi",
    "jg": "Giá",
    "sl": "Số lượng",
    "gg": "Đòn bẩy",
    "tzgg": "Điều chỉnh đòn bẩy",
    "ggbs": "Đòn bẩy",
    "mrl": "Khối lượng mua",
    "ky": "Khả dụng",
    "jye": "Giao dịch",
    "dqwt": "Lệnh mở",
    "lswt": "Hoa hồng lịch sử",
    "ptwt": "Hoa hồng thông thường",
    "dqwtmr": "Lệnh hiện thời (Mua)",
    "dqwtmc": "Lệnh hiện thời (Bán)    ",
    "hywt": "Hoa hồng theo hợp đồng",
    "jj": "Thông tin",
    "wtzl": "Toàn bộ",
    "wtjg": "Giá hoa hồng",
    "ycjl": "Khối lượng giao dịch hoàn tất",
    "cjjj": "Mức giá giao dịch trung bình",
    "cd": "Rút tiền",
    "xd": "Đặt một lệnh",
    "wqcj": "Giao dịch hoàn tất",
    "ywc": "Đã hoàn tất",
    "ycd": "Đã rút",
    "zx": "Tùy chọn",
    "scjg": "Giá thị trường",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "mrzd": "Mua dài hạn",
    "mrpk": "Mua ngắn hạn ",
    "mczk": "Bán ngắn hạn ",
    "mcpd": "Bán dài hạn",
    "mrkdkz": "Mua khi mở (tăng giá)",
    "mrpkkz": "Mua khi đóng (tăng giá)",
    "mckkkd": "Bán khi mở (giảm giá)",
    "mcpdkd": "Bán khi đóng (giảm giá)",
    "yxhy": "Hợp đồng vĩnh viễn",
    "dc": "Vị thế dài hạn",
    "syl": "Lợi suất",
    "bzjl": "Tỷ lệ ký quỹ",
    "tzbzj": "Điều chỉnh ký quỹ",
    "zyzs": "Chốt lãi & cắt lỗ",
    "zhang": "Số lượng",
    "qblx": "Tất cả các loại",
    "qb": "Tất cả các",
    "ccjg": "Mức giá vị thế",
    "ccsl": "Số lượng vị thế",
    "yk": "Lãi và lỗ",
    "ccsj": "Thời gian của vị thế",
    "zy": "Chốt lãi",
    "zs": "Cắt lỗ",
    "zje": "Tổng tiền",
    "kcs": "Số lượng vị thế mở",
    "kcjg": "Mức giá vị thế mở",
    "ss": "Lô",
    "hand": "1 lô =",
    "qx": "Hủy",
    "qr": "Xác nhận",
    "qbcd":"Hủy tất cả các đơn đặt hàng"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "Lệnh đang chờ",
    "cj": "Thỏa thuận",
    "jj": "Thông tin",
    "sj": "Thời gian",
    "fx": "Xu hướng",
    "jg": "Giá",
    "sl": "Số lượng",
    "mr": "Mua",
    "mc": "Bán",
    "mp": "Đấu thầu",
    "sp": "Đang bán",
    "slb": "Số lượng",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
    "ft": "Ảnh phụ",
    "zt": "Ảnh chính",
    "sdt": "Độ sâu",
    "zx": "Tùy chọn",
    "djck": "Bấm để xem"
  },
  "zhjl": {
    "cbtb": "Ký quỹ & Rút tiền",
    "jymx": "Chi tiết giao dịch",
    "tgyj": "Hoa hồng khuyến mại",
    "wwc": "Hoàn tác",
    "ywc": "Đã hoàn tất"
  },
  "zwsj": {
    "title": "Không có dữ liệu"
  },
  "bzxz": {
    "title": "Lựa chọn tiền tệ"
  },
  "jghy": {
    "jghy": "tương lai",
    "yxhy": "vĩnh viễn",
    "mz": "Tăng giá",
    "md": "Giảm giá",
    "gmj": "Giá mua",
    "jsj": "Giá thanh toán",
    "xj": "Giá hiện thời",
    "fx": "Xu hướng",
    "sl": "Số lượng",
    "jgsj": "Thời gian giao",
    "gb": "Đóng",
    "jxxd": "Tiếp tục đặt lệnh",
    "cclb": "Danh sách lệnh",
    "zc": "Hiện thời",
    "lscc": "Lịch sử",
    "qblx": "Tất cả các loại",
    "yk": "Lãi và lỗ",
    "ddqr": "Xác nhận lệnh",
    "dqsj": "Thời gian hết hạn",
    "jssj": "Thời gian giao",
    "sy": "Lãi",
    "tzje": "Mức giá đầu tư",
    "zdje": "Giá thấp nhất 0",
    "kyye": "Thăng bằng: ",
    "kyye2": "Thăng bằng",
    "sxf": "Phí: ",
    "sxfl": "Phí",
    "jypz": "Tên",
    "jyfx": "Xu hướng",
    "qrxd": "Xác nhận",
    "dqye": "Số dư hiện thời"
  },
  "kjmb": {
    "title": "Tiền điện tử",
    "gm": "Mua USDT",
    "wxts": "Lời nhắc:",
    "copy": "Sao chép",
    "ljmb": "Mua tiền điện tử",
    "qx": "Hủy",
    "gmsl": "Số lượng mua",
    "cssl": "Số lượng đã bán",
    "qsrgmsl": "Vui lòng nhập số lượng mua",
    "qsrcssl": "Vui lòng nhập số lượng bán",
    "jg": "Giá",
    "fzcg": "Sao chép thành công"
  },
  "tips": {
    "jymm": "Mật khẩu giao dịch",
    "szjymm": "Đặt mật khẩu rút tiền",
    "qsrjymm": "Vui lòng nhập mật khẩu giao dịch",
    "jymmts": "Vui lòng truy cập Trung tâm Bảo mật để đặt mật khẩu giao dịch"
  },
  "xyf":{
    "title": "Điểm tín dụng",
    "pgsj": "Thời gian đánh giá"
  },
  "dzrz":{
    "title": "Xác thực địa chỉ",
    "sdddz":"Địa chỉ hóa đơn tiện ích",
    "tpsc": "tải hình ảnh Bill",
    "ts": "Nhắc nhở: Bạn cần điền thông tin địa chỉ và gửi hóa đơn điện nước hoặc hóa đơn địa chỉ băng thông rộng",
    "tips":"Bạn cần điền thông tin địa chỉ và gửi hóa đơn điện nước hoặc hóa đơn địa chỉ băng thông rộng",
    "qsczdtp":"tải hình ảnh Bill"
  },
  "newReg":{
    "sjh": "điện thoại di động",
    "yx": "e-mail",
    "yqm": "Mã mời",
    "yqm2": "Mã lời mời (tùy chọn)",
    "cjzh": "Tạo tài khoản",
    "sysjhzyx": "Đăng ký bằng số điện thoại di động / email",
    "sj": "Di động",
    "yhxy": "&lt;Thoản thuận người dung&gt;",
    "yhxy2": "Tôi đã đọc và đồng ý với &lt;Thoản thuận người dung&gt;"
  },
  "mbwt":{
    "title": "Vấn đề An ninh",
    "mbwt": "Vấn đề An ninh",
    "qtxda": "Vui lòng trả lời",
    "qsrxmm": "Vui lòng nhập mật khẩu mới",
    "sydqmmcz": "Sử dụng Đặt lại Mật khẩu Hiện tại",
    "zhmm": "Vấn đề bảo mật Lấy lại mật khẩu",
    "ysz": "Cài đặt",
    "tg": "Bỏ qua",
    "tj": "Gửi đi",
    "zyts": "Quan trọng:",
    "zytsCont": "Không tiết lộ câu trả lời bí mật và mã xác minh, đồng thời lưu ý vấn đề bảo mật, điều này sẽ giúp bạn lấy lại mật khẩu của mình"
  },
  "xbsg":{
    "title": "Khu vực tiền xu mới",
    "wdsg": "Thông tin chi tiết",
    "scts": "Ngày nhốt: ",
    "sy": "còn lại",
    "ljsg": "Theo dõi ngay",
    "ysk": "Bán hết",
    "xzjdy": "Theo dõi ngay",
    "dy": "Đặt mua",
    "fxjg": "giá phát hành",
    "fxl": "Vòng tuần hoàn",
    "ssrq": "Ngày niêm yết",
    "yxqx": "Thời gian hiệu lực",
    "qsrsl": "Vui lòng nhập số tiền",
    "syl": "còn lại",
    "sgrq": "đặt mua",
    "sgsl": "Số lượng",
    "bz": "Đồng tiền",
    "yebz": "Số dư USDT không đủ",
    "tgsl": "Vượt qua Qty",
    "shz": "đang xem xét",
    "wtg": "Không vượt qua",
    "ytg": "thông qua"
  },
  "wydb":{
    "title": "Vay",
    "db": "Vay",
    "dbz": "Vay",
    "jl": "ghi lại",
    "jdzq": "vay (ngày)",
    "qhk": "Trả lại",
    "ljdb": "Tích lũy (usdt)",
    "dhkbs" :"Trong khi chờ thanh toán",
    "jkje": "số tiền (usdt)",
    "qsrje": "Vui lòng nhập số tiền",
    "rll": "Lãi suất hàng ngày",
    "hkfs": "Trả nợ",
    "dqych": "Hết hạn",
    "lx": "Quan tâm",
    "fkjg": "Người cho vay",
    "tpsc": "Khoản vay tín dụng (tải lên hình ảnh)",
    "fwxx": "Thông tin nhà ở",
    "srzm": "Chứng minh thu nhập (mối quan hệ việc làm)",
    "yhmx": "Sao kê ngân hàng",
    "zjz": "Ảnh ID",
    "yd": "Tôi đã đọc và đồng ý",
    "xy": "Đăng ký hợp đồng vay",
    "sqdb": "đăng ký chuỗi cho vay",
    "gb": "Khép kín",
    "qd": "VÂNG",
    "ts": "Vui lòng kiểm tra Đăng ký hợp đồng vay",
    "dbjl": "ghi lại",
    "hkhth": "Mã đặt hàng",
    "wsh": "Chưa được đánh giá",
    "yfk": "Tiền vay",
    "sqrq": "thời gian nộp đơn",
    "zq": "xe đạp",
    "dbsl": "số lượng",
    "zhke": "Tổng tiền thanh toán",
    "yhkxq": "Chi tiết trả nợ",
    "bqyhk": "Phải trả trong kỳ hiện tại(USDT)",
    "hktips": "Hãy đảm bảo số dư còn đủ, nếu số dư không đủ vui lòng nạp tiền trước rồi hoàn trả",
    "bj": "Hiệu trưởng",
    "jie": "Vay",
    "ljhk": "Trả nợ ngay lập tức",
    "qcz": "Gửi tiền",
    "yebzqxcz": "Không đủ số dư, vui lòng nạp tiền trước và sau đó hoàn trả",
    "znj": "phí thanh toán chậm",
    "yqts": "Ngày quá hạn"
  },
  "hkxq":{
    "dd":"Gọi món",
    "fzhkdz":"Sao chép địa chỉ trả nợ",
    "hkxq": "Chi tiết trả nợ",
    "zlx": "tổng lãi",
    "zhk": "tổng số tiền hoàn trả",
    "hkjg": "cơ quan trả nợ",
    "qschkpz": "Vui lòng tải lên chứng chỉ hoàn trả",
    "hkpz": "giấy chứng nhận trả nợ"
  },
  "bbjyNew":{
    "jylx": "Các loại",
    "jyze": "Số lượng"
  },
  "indexNew":{
    "title": "Thêm Spmaxex vào giao diện chính",
    "t1": "Truy cập nhanh vào trải nghiệm toàn màn hình",
    "t2": "Nhấp vào thanh công cụ bên dưới",
    "t3": "và chọn",
    "t4": "Thêm vào màn hình chính",
    "t5": "Thêm vào trải nghiệm máy tính để bàn phiên bản đầy đủ của Spmaxex",
    "t6": "Thêm vào mục ưa thích",
    "t7": "Tìm trên trang"
  },
  "bind":{
    "title": "email",
    "ybd": "Ràng buộc",
    "wbd": "Không ràng buộc",
    "yrz": "Đã xác minh",
    "wrz": "Chưa xác minh",
    "ts": "Để bảo vệ tài khoản của bạn, bạn nên liên kết một địa chỉ email",
    "qsryxdz": "địa chỉ email"
  },
  "status":{
    "statusText": ['sự thất bại','Đang chờ được xử lý','sự thành công'],
 },
 "tipsNew":{
   "wjmmts": "Khôi phục mật khẩu bằng mã xác minh",
   "qscpztp": "Tải lên hình ảnh phiếu thưởng",
   "emailgsts": "Vui lòng nhập email hợp lệ",
   "telgsts": "Số điện thoại di động không chính xác",
   "lcmmbyz": "Vui lòng xác nhận mật khẩu của bạn",
   "zdsl": "Tối thiểu ",
   "sldydy": "Số lượng lớn hơn hoặc bằng",
   "zxtzsl": "Tối thiểu ",
   "ddz": "Đang chờ đợi",
   "xs": "Giờ",
   "min": "Số tiền tối thiểu ",
   "max": "Số tiền tối đa ",
   "yebz": "Thiếu cân bằng",
   "qsrss": "Vui lòng nhập lô",
   "zdss": "Số lô tối thiểu",
   "yjj": "từ chối",
   "shz": "chuộc lỗi",
   "zwkfcz": "Đơn vị tiền tệ này chưa mở để nạp tiền",
   "jiaoge": "Giao hàng",
    "zhang": "tăng",
    "die": "rơi",
    "cjxnzh": "Tạo tài khoản ảo"
 },
 "langNew2":{
  "flzq": "Trung tâm phần thưởng",
  "qdjl": "Đăng nhập phần thưởng",
  "mrqdjl": "Phần thưởng đăng nhập hàng ngày",
  "qd": "Đăng nhập",
  "yqd": "Đăng nhập",
  "hdgz": "Thể lệ sự kiện",
  "qdjl2": "Nhật ký nhập cảnh",
  "qdcg": "Đăng nhập thành công",
  "yhd": "Đã nhận được",
  "lq": "Nhận",
  "dyt": "Ngày 1",
  "det": "Ngày 2",
  "dst": "Ngày 3",
  "dsit": "Ngày 4",
  "dwt": "Ngày 5",
  "dlt": "Ngày 6",
  "dqt": "Ngày 7",
  "jxz": "đang tiến hành"
},
"langNew":{
  "kp": "Khai mạc",
  "zuoshou": "nhận được ngày hôm qua",
  "zg": "cao nhất",
  "zd": "thấp nhất",
  "dqjg": "Giá hiện tại",
  "pcjg": "Giá đóng cửa",
  "gd": "danh sách hàng chờ",
  "gdj": "Giá đặt hàng đang chờ xử lý",
  "gdjg": "Giá đặt hàng đang chờ xử lý",
  "xfbzj": "Yêu cầu đặt cọc bảo đảm: ",
  "ksrfw": "Phạm vi đầu vào khả dụng: ",
  "shou": "Rất nhiều",
  "fdjyk": "lãi và lỗ ròng thả nổi",
  "pcsl": "Đóng số lượng",
  "cx": "thu hồi",
  "qrpc": "Xác nhận đóng vị thế",
  "sx": "lọc",
  "cz": "cài lại",
  "zdl": "biết",
  "kccg": "Đã mở thành công một vị thế!",
  "xzfx": "chọn hướng",
  "lx": "kiểu",
  "xgcc": "sửa đổi vị trí",
  "szzyzs": "Đặt dừng lợi nhuận và dừng lỗ",
  "szhb": "tiền điện tử",
  "gjs": "Kim loại",
  "yy": "thô",
  "jy": "Buôn bán",
  "jmhb": "tiền điện tử",
  "gdsj": "Thời gian đặt hàng đang chờ xử lý",
  "gdsl": "Số lượng đặt hàng đang chờ xử lý",
  "fs": "time"
 },
 "ieo":{
   "ieo": "IEO",
   "csjg": "giá ban đầu",
   "syl": "số lượng còn lại",
   "sjd": "đặt hàng ở siêu thị",
   "jj": "giá trung bình",
   "zsl": "Tổng số lượng",
   "zyk": "Tổng lãi lỗ",
   "ljmr": "Mua ngay",
   "yqx": "Đã hủy",
   "gmjl": "Lịch sử mua hàng",
   "yjs": "Qua",
   "jzrq": "Ngày hết hạn",
   "xjcz": "Nạp tiền mặt",
   "djlxkf": "Nếu bạn sử dụng Yên Nhật để gửi tiền, vui lòng nhấp vào để liên hệ với bộ phận dịch vụ khách hàng",
   "qrrjts": "Nếu bạn sử dụng USD để gửi tiền, vui lòng liên hệ với bộ phận dịch vụ khách hàng",
   "mmts": "Chỉ cho phép chữ hoa và chữ thường cộng với số"
  },
  "langNew4":{
    "qsrndzh": "Vui lòng nhập số tài khoản của bạn",
    "ljcb": "Gửi tiền ngay bây giờ",
    "ljtb": "Rút xu ngay lập tức",
    "flhd": "Hoạt động phúc lợi",
    "flzx": "Trung tâm phúc lợi",
    "lqjl": "Nhận phần thưởng cao nhất",
    "wyzq": "tôi đã kiếm được",
    "hdlb": "Danh sách sự kiện",
    "dk": "khoản vay",
    "kyje": "Số tiền có sẵn",
    "je": "Số lượng",
    "zd": "tối đa",
    "wxj": "Tôi muốn mượn...",
    "dkjl": "lịch sử cho vay",
    "xydk": "Khoản vay tín dụng",
    "tpsc": "tải ảnh lên",
    "dkts": "Không tính lãi trong 3 ngày sau khi nhận khoản vay và lãi sẽ được trả sau đó",
    "ljdk": "Vay ngay bây giờ",
    "qwc": "hoàn thành"
  },
  share:{
    "hd": "Nhận phần thưởng tiền điện tử",
    "yqhy": "Mời bạn bè của bạn tham gia định lượng Ai, thuê máy khai thác và giao dịch sản phẩm để nhận phần thưởng tiền điện tử",
    "yqsy": "Thu nhập từ lời mời",
    "yqrs": "Số người được mời",
    "yqlj": "Mời qua liên kết",
    "lj": "liên kết",
    "yqm": "Mã mời",
  },
  myAssets:{
    "cz": "nạp tiền",
    "wzh": "Gửi tiền kỹ thuật số hoặc tiền hợp pháp vào tài khoản của bạn",
    "tx": "rút",
    "xyzh": "Rút tài sản từ tài khoản hiện có về thẻ ngân hàng hoặc ví của bạn",
  },
  user:{
    "zcgl": "quản lý tài sản",
    "xb": "tiền tệ mới",
    "hd": "Hoạt động và phần thưởng",
    "zhxg": "Tài khoản liên quan",
    "kf": "dịch vụ khách hàng",
    "sfrz": "Xác thực",
    "aq": "Sự an toàn",
    "gy": "Về",
    "sz": "Cài đặt",
    "gp": "Cổ phần",
    "wh": "Ngoại hối"
  },
  "langNew3":{
      "xw":"Tin tức",
    "gdgnjxz":"Chức năng sao chép lệnh đang được tiến hành",
    "gdts":"Bắt đầu sao chép lệnh, lợi nhuận cao, lợi nhuận cao, cho phép bạn kiếm được tiền mà không cần bất kỳ nỗ lực nào",
    "ksgd":"Bắt đầu sao chép",
    "gd":"Theo dõi",
    "gdlx1":"AI GPT",
    "gdlx2":"Chính trị gia",
    "gdlx3":"Nhà giao dịch",
    "npjsy":"Thu nhập trung bình hàng năm",
    "gtrs":"Số lượng nhà đầu tư theo dõi",
    "hbl":"Tỷ lệ hoàn vốn",
    "gtje":"Số tiền đầu tư theo dõi",
    "gt":"Đầu tư theo dõi",
    "gdz":"Theo dõi",
    "ywc":"Hoàn thành",
    "zdf":"Tăng và giảm",
    "tz":"Dừng",
    "bdy":"Không ít hơn",
    "xwxq":"Chi tiết tin tức",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/vn.js